/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientsService {
    /**
     * List all clients
     * Get a paginated list of clients for the authenticated user
     * @param isActive Filter by active status
     * @param clientType Filter by client type
     * @param search Search in name, email, or mobile
     * @returns any List of clients
     * @throws ApiError
     */
    public static e670D7D89A727399362952De764670F(
        isActive?: 'Yes' | 'No',
        clientType?: 'single' | 'multiple',
        search?: string,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/advocate-clients',
            query: {
                'is_active': isActive,
                'client_type': clientType,
                'search': search,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new client
     * Create a new client. Can create a new person or link to existing person
     * @param requestBody
     * @returns any Client created successfully
     * @throws ApiError
     */
    public static d277802F6Aab301945Ea50B60B15Dda(
        requestBody: {
            name: string;
            company_name?: string | null;
            /**
             * Link to existing person
             */
            people_id?: number | null;
            /**
             * Required if people_id not provided
             */
            first_name?: string;
            last_name?: string | null;
            email?: string | null;
            mobile?: string | null;
            address?: string | null;
            client_type: 'single' | 'multiple';
            reference_name?: string | null;
            reference_mobile?: string | null;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/advocate-clients',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific client
     * Retrieve details of a specific client
     * @param id Client ID
     * @returns any Client details
     * @throws ApiError
     */
    public static a4606F1D8605B3C834Fecfb920E9565(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/advocate-clients/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Client not found`,
            },
        });
    }
    /**
     * Update a client
     * Update an existing client and optionally update linked person data
     * @param id Client ID
     * @param requestBody
     * @returns any Client updated successfully
     * @throws ApiError
     */
    public static ead132E58B447B79Af61732D0298B(
        id: number,
        requestBody: {
            name?: string;
            /**
             * Update person data
             */
            first_name?: string;
            email?: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/advocate-clients/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Client not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete a client
     * Delete a client
     * @param id Client ID
     * @returns any Client deleted successfully
     * @throws ApiError
     */
    public static bc860Ba00514332C1100E3E18D51B35(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/advocate-clients/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Client not found`,
            },
        });
    }
}
